import { Component, OnInit, Input } from '@angular/core';
import { TournamentsService } from '@app/services/tournaments/tournaments.service';
import { PositionList, TournamentTeam } from '@app/_models/tournament.model';

@Component({
  selector: 'tournament-positions',
  templateUrl: './tournament-positions.component.html',
  styleUrls: ['./tournament-positions.component.scss'],
})
export class TournamentPositionsComponent implements OnInit {
  constructor(private _tournamentService: TournamentsService) { }
  @Input() tournamentId: number;
  positions: PositionList;
  displayedColumns = [
    'team',
    'played_matches',
    'won_matches',
    'tied_matches',
    'lost_matches',
    'difference',
    'points',
  ];
  tournamentTeams: TournamentTeam[] = [];

  ngOnInit() {
    this.getPositions();
    this._tournamentService.getTournamentTeams().subscribe(teams => {
      this.tournamentTeams = teams;
    });
  }

  getPositions() {
    this._tournamentService
      .getTournamentPositions(this.tournamentId)
      .subscribe(positions => {
        this.positions = positions;
      });

  }

  getTeamProperty(teamId, property) {
    const team = this.tournamentTeams.find(team => team.id === teamId);
    return team[property];
  }
}
